import { api } from '../api';
import { GET_406, GET_BANNER } from '../../constants/banner';
import { GetBannerRequest, GetBannerResponse } from './types';

export const bannerSlice = api.injectEndpoints({
  endpoints: (build) => ({
    // getBanner: build.query<GetBannerResponse, GetBannerRequest>({
    //   query: (data) => ({
    //     url: GET_BANNER,
    //     params: {
    //       category: data.category // Send the category parameter here
    //     }
    //   })
    // }),
    getBanner: build.query<GetBannerResponse, GetBannerRequest>({
      query: () => ({
        url: GET_BANNER
      }),
      // Banners change rarely and the response carries the images inline: keep it for an hour
      // instead of re-downloading it on most dashboard visits.
      keepUnusedDataFor: 3600
    }),
    get406: build.query<void, void>({
      query: () => `${GET_406}`
    })
  }),
  overrideExisting: false
});

export const { useGetBannerQuery, useLazyGetBannerQuery, useGet406Query } =
  bannerSlice;
